enum SignalRGroupType {
  JobActivity = 'activityUpdate',
  JobUpdate = 'jobUpdate',
  JobUpdateChannel = 'jobUpdateChannel',
}

export default SignalRGroupType;
